import { AloAllergeneLg, getDefaultAloAllergeneLg } from "./AloAllergeneLg"
import { AloBase, getDefaultAloBase } from "./AloBase"


export interface AloAllergene extends AloBase  {          
    lgs:Array<AloAllergeneLg>
}

export const getDefaultAloAllergene = ():AloAllergene => {
    return {
        ...getDefaultAloBase(),
        lgs:[getDefaultAloAllergeneLg()]
    }
}